import { useQuery } from '@tanstack/react-query';
import { getIsSensorHasData } from 'common/services/sensors.service';

const useIsIntegrationHasData = integrationId => {
  const { data: hasData = null, isLoading } = useQuery({
    enabled: !!integrationId,
    retry: false,
    refetchOnWindowFocus: false,
    queryKey: ['isIntegrationHasData', integrationId],
    queryFn: async () => {
      return await getIsSensorHasData(integrationId);
    }
  });

  return {
    isLoading,
    hasData
  };
};

export default useIsIntegrationHasData;
